const isPublicWebsiteHost = () => {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'kodacare.pet' || host === 'www.kodacare.pet' || host.includes('kodacare-website');
};

/**
 * Builds a website route that works both:
 * - on kodacare.pet (root-based: /blog)
 * - when embedded in app host (prefixed: /website/blog)
 */
export function websitePath(path: string = '/'): string {
  const clean = path.startsWith('/') ? path : `/${path}`;
  if (isPublicWebsiteHost()) return clean;
  return clean === '/' ? '/website' : `/website${clean}`;
}
